import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
export default function PutAway({ onClick, ariaLabel = 'dismiss' }) {
    const closeUsingKeyboard = React.useCallback((event) => {
        if ([' ', 'Escape', 'Enter'].includes(event.key)) {
            onClick();
            event.preventDefault();
            event.stopPropagation();
        }
    }, [onClick]);
    return (React.createElement("span", { className: 'put-away', "aria-label": ariaLabel, role: 'button', onClick: onClick, tabIndex: 0, onKeyDown: closeUsingKeyboard, "data-nudge-action": 'dismissed' },
        React.createElement(FontAwesomeIcon, { icon: faTimes })));
}
